import { render, staticRenderFns } from "./CustomItem.vue?vue&type=template&id=01d0cf10&scoped=true&"
import script from "./CustomItem.vue?vue&type=script&lang=js&"
export * from "./CustomItem.vue?vue&type=script&lang=js&"
import style0 from "./CustomItem.vue?vue&type=style&index=0&id=01d0cf10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d0cf10",
  null
  
)

export default component.exports